import React from 'react';
import './ServerStreaming.css';

const ServerStreaming = () => {
  return (
    <div className="server-streaming-page">
      <div className="container">
        {/* Header */}
        <header className="header">
          <h1>Module 3: Server Streaming</h1>
          <p className="subtitle">Fastest Setup &amp; Lightweight Cloud Solution</p>
          <span className="module-badge">Remote Server Solution</span>
        </header>

        {/* Workflow */}
        <section className="workflow-section">
          <h2 className="section-title">How Users Work with Module 3</h2>

          <div className="workflow-diagram">
            <div className="workflow-step">
              <div className="step-icon">🌐</div>
              <h3 className="step-title">Step 1: Connect</h3>
              <p className="step-desc">Open browser → connect to our server → stream your camera/microphone</p>
            </div>

            <div className="arrow-connector">
              <span className="arrow-label">Stream to</span>
              <div className="arrow-line"></div>
            </div>

            <div className="workflow-step">
              <div className="step-icon">🖥️</div>
              <h3 className="step-title">Step 2: Server Exam</h3>
              <p className="step-desc">Proctor runs on our server with real hardware → sees your stream as real camera</p>
            </div>

            <div className="arrow-connector">
              <span className="arrow-label">You're free</span>
              <div className="arrow-line"></div>
            </div>

            <div className="workflow-step">
              <div className="step-icon">🎯</div>
              <h3 className="step-title">Step 3: Total Freedom</h3>
              <p className="step-desc">Use your PC freely OR enable video loop and walk away - proctor sees nothing</p>
            </div>
          </div>
        </section>

        {/* Split View */}
        <section className="split-view-section">
          <h2 className="section-title">What Proctor Sees vs Reality</h2>

          <div className="split-container">
            {/* Proctor */}
            <div className="view-panel proctor-view">
              <div className="view-header">
                <span className="view-icon">👁️</span>
                <h3 className="view-title">Proctor's View (On Server)</h3>
                <span className="view-status status-deceived">Deceived</span>
              </div>
              <div className="view-content">
                <div className="screen-mockup">
                  <div className="server-window">
                    <div className="server-header">
                      <span className="server-icon">☁️</span>
                      <span className="server-title">Server - Real Hardware</span>
                    </div>
                    <div className="exam-block">
                      <div className="exam-title">Physics Exam - Question 8</div>
                      <div className="exam-text">Student taking exam on server. Everything normal.</div>
                    </div>
                  </div>

                  <div className="camera-feed">
                    <div className="camera-icon">📹</div>
                    <div className="camera-label">Student Camera Feed (Streamed)</div>
                    <div className="loop-indicator">
                      <span className="loop-icon">🔄</span>
                      <span>Video Loop Active</span>
                    </div>
                  </div>
                </div>

                <div className="monitoring-list">
                  <div className="monitor-item">
                    <span className="monitor-icon">🖥️</span>
                    <div className="monitor-text">
                      <div className="monitor-label">System Location</div>
                      <div className="monitor-status">Student on server</div>
                    </div>
                  </div>
                  <div className="monitor-item">
                    <span className="monitor-icon">📹</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Camera Stream</div>
                      <div className="monitor-status">Looped video playing</div>
                    </div>
                  </div>
                  <div className="monitor-item">
                    <span className="monitor-icon">🔍</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Screen Monitor</div>
                      <div className="monitor-status">Server screen only</div>
                    </div>
                  </div>
                  <div className="monitor-item">
                    <span className="monitor-icon">🛡️</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Hardware Check</div>
                      <div className="monitor-status">Real server hardware</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Reality */}
            <div className="view-panel reality-view">
              <div className="view-header">
                <span className="view-icon">✨</span>
                <h3 className="view-title">Actual Reality (Your PC)</h3>
                <span className="view-status status-active">Unrestricted</span>
              </div>
              <div className="view-content">
                <div className="screen-mockup">
                  <div className="browser-connected">
                    <div className="browser-title">🌐 Browser Connected to Server</div>
                    <div className="browser-sub">Exam running on remote server...</div>
                  </div>

                  <div className="client-system">
                    <span className="client-label">Your Computer - Complete Freedom</span>
                    <div className="client-content">
                      <div className="client-app">
                        <span className="app-icon">🌐</span>
                        <span className="app-name">Google</span>
                      </div>
                      <div className="client-app">
                        <span className="app-icon">💬</span>
                        <span className="app-name">Discord</span>
                      </div>
                      <div className="client-app">
                        <span className="app-icon">🎮</span>
                        <span className="app-name">Games</span>
                      </div>
                      <div className="client-app">
                        <span className="app-icon">☕</span>
                        <span className="app-name">AFK - Getting tea</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="monitoring-list">
                  <div className="monitor-item">
                    <span className="monitor-icon">🎯</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Your Actions</div>
                      <div className="monitor-status">Completely invisible</div>
                    </div>
                  </div>
                  <div className="monitor-item">
                    <span className="monitor-icon">🔄</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Video Loop</div>
                      <div className="monitor-status">Can walk away anytime</div>
                    </div>
                  </div>
                  <div className="monitor-item">
                    <span className="monitor-icon">🌍</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Location</div>
                      <div className="monitor-status">Can be anywhere in world</div>
                    </div>
                  </div>
                  <div className="monitor-item">
                    <span className="monitor-icon">🚀</span>
                    <div className="monitor-text">
                      <div className="monitor-label">Usage</div>
                      <div className="monitor-status">No restrictions whatsoever</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="features-section">
          <h2 className="section-title">Module 3 Key Features</h2>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon-box">⚡</div>
                <h3 className="feature-title">Instant Setup</h3>
              </div>
              <p className="feature-desc">Fastest deployment - just open browser and connect. No installation needed on your computer.</p>
              <ul className="feature-list">
                <li>Browser-based connection</li>
                <li>No software installation</li>
                <li>Ready in seconds</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon-box">🪶</div>
                <h3 className="feature-title">Ultra Lightweight</h3>
              </div>
              <p className="feature-desc">Zero local storage required. Everything runs on our powerful servers.</p>
              <ul className="feature-list">
                <li>0 MB installation size</li>
                <li>Works on any device</li>
                <li>Low system requirements</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon-box">🔄</div>
                <h3 className="feature-title">Video Loop Feature</h3>
              </div>
              <p className="feature-desc">Record 30 seconds of yourself sitting calmly - then loop it while you walk away to grab coffee!</p>
              <ul className="feature-list">
                <li>Automated video looping</li>
                <li>Leave computer entirely</li>
                <li>Proctor sees continuous feed</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon-box">☁️</div>
                <h3 className="feature-title">Real Server Hardware</h3>
              </div>
              <p className="feature-desc">Proctor runs on actual server hardware - not VM, not emulation. Impossible to detect.</p>
              <ul className="feature-list">
                <li>Real physical servers</li>
                <li>No virtualization traces</li>
                <li>Genuine hardware signatures</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Specs */}
        <section className="specs-section">
          <h2 className="specs-title">Module 3 Specifications</h2>

          <div className="specs-grid">
            <div className="spec-item">
              <div className="spec-icon">⚡</div>
              <div className="spec-label">Setup Speed</div>
              <div className="spec-value">Instant - just connect</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">🪶</div>
              <div className="spec-label">Installation Size</div>
              <div className="spec-value">0 MB - browser only</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">📶</div>
              <div className="spec-label">Internet Required</div>
              <div className="spec-value">Stable connection needed</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">🌐</div>
              <div className="spec-label">Latency Sensitive</div>
              <div className="spec-value">Low ping recommended</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">☁️</div>
              <div className="spec-label">Server Dependency</div>
              <div className="spec-value">Requires our infrastructure</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">🌍</div>
              <div className="spec-label">Global Access</div>
              <div className="spec-value">Take exam from anywhere</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">🖥️</div>
              <div className="spec-label">Device Support</div>
              <div className="spec-value">Any PC/laptop with browser</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">🔄</div>
              <div className="spec-label">Video Loop</div>
              <div className="spec-value">Walk away anytime</div>
            </div>
            <div className="spec-item">
              <div className="spec-icon">🎯</div>
              <div className="spec-label">Detection Rate</div>
              <div className="spec-value">Real hardware - undetectable</div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="footer-banner">
          <p className="footer-text">Cloud-Powered Solution for Instant Deployment &amp; Maximum Flexibility</p>
        </div>
      </div>
    </div>
  );
};

export default ServerStreaming;
